
interface SquareGameDisplayProps {
  number: number;
  answer: number;
  showAnswer: boolean;
  isBlocked?: boolean;
}

const funnyMessages = [
  "Squares need space to breathe! 🟦",
  "Even geometry needs a moment 📐",
  "Your math powers are too strong! Take a tiny break ⚡",
  "Squares say: 'One at a time, please!' 🎲",
  "Let's square these numbers gently 🌸",
  "Math magic needs to recharge! ✨",
  "Slow and steady wins the math race! 🐌",
  "Time for a quick square dance break! 💃"
];

export const SquareGameDisplay: React.FC<SquareGameDisplayProps> = ({
  number,
  answer,
  showAnswer,
  isBlocked,
}) => {
  const randomMessage = () => funnyMessages[Math.floor(Math.random() * funnyMessages.length)];

  return (
    <div className="text-center mb-8">
      <div className="bg-gradient-to-br from-indigo-50 to-purple-50 dark:from-indigo-900/20 dark:to-purple-900/20 p-8 rounded-xl border border-indigo-100 dark:border-indigo-800 transition-colors duration-200">
        <h2 className="text-5xl font-bold mb-4 bg-gradient-to-r from-indigo-600 to-purple-600 dark:from-indigo-400 dark:to-purple-400 bg-clip-text text-transparent">
          {number}² = {showAnswer ? answer : '?'}
        </h2>
        <p className="text-sm font-medium text-gray-600 dark:text-gray-400">
          {isBlocked ? (
            <span className="text-amber-600 dark:text-amber-400">{randomMessage()}</span>
          ) : (
            showAnswer ? 'Press → or Space for next question' : 'Press → or Space to see answer'
          )}
        </p>
      </div>
    </div>
  );
};